import { AiOutlineDownload } from "react-icons/ai";
import { Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";

const MyComponent = () => {
    const pdfPreviewUrl = "https://drive.google.com/file/d/19IggVvIdv9L1Zx3Pj5C34W597Eg3xmZm/preview";
    const pdfDownloadUrl = "https://drive.google.com/uc?export=download&id=19IggVvIdv9L1Zx3Pj5C34W597Eg3xmZm"
    
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfDownloadUrl;
    link.download = "CV.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: "100vh",
        paddingTop: "80px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {/* Centered Download Button */}
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            onClick={handleDownload}
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        {/* A4-Styled CV Viewer */}
        <div
          style={{
            width: "210mm",
            height: "297mm",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            border: "1px solid #ddd",
            backgroundColor: "#fff",
            overflow: "hidden",
          }}
        >
          <iframe
            src={pdfPreviewUrl}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="PDF Viewer"
          ></iframe>
        </div>
      </div>
    </div>
  );
    };
  
  export default MyComponent;
  